export class Paginacao {

    quantidadeRegistrosPorPagina: number;
    paginaAtual: number;

    constructor() {
        this.quantidadeRegistrosPorPagina = 0;
        this.paginaAtual = 0;
    }

}
